import React from "react";
import PostDetails from "./postDetails";
import { getAllReportedPostList } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import ReportedPostTable from "../../../components/reportManagement/ReportedPostTable";

/**
 * @function Post
 * @description for Post
 * @returns JSX for Post
 */
const Post = ({ selectedPostId, selectedIdHandler }) => {
  const { pageNo, limit, searchKey, sortOrder, sortBy } = useSelector(
    (state) => state.ReportReducer.post.reportedPost
  );
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getAllReportedPostList());
  }, [pageNo, limit, searchKey, sortOrder, sortBy, selectedPostId]);

  
  return (
    <div>
      {selectedPostId.length === 0 ? (
        <ReportedPostTable selectedIdHandler={selectedIdHandler} />
      ) : (
        <PostDetails selectedPostId={selectedPostId} />
      )}
    </div>
  );
};

export default Post;
